const freightBillStatus = {
  APPROVED: 1,
  PARTIAL: 2,
  NOT_APPROVED: 3,
};

const erpPostStatus = {
  POSTED: 1,
  NOT_POSTED: 2,
};

module.exports = {
  freightBillStatus,
  erpPostStatus,
};
